import Vue, { defineComponent } from 'vue';
import TemplatePostGrid from '@/modules/post/template-post-grid';
Vue.component('template-customer-story-card-list', defineComponent({
    extends: TemplatePostGrid,
}));
